import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { WeathermapTokenService } from 'src/app/services/weathermap-token.service';

@Injectable({ providedIn: 'root' })
export class WeathermapService {
  weathermapTokenService = inject(WeathermapTokenService);
  httpClient = inject(HttpClient);

  post<T>(endpoint: string, params: Record<string, unknown>): Observable<T> {
    return this.httpClient.post<T>(`${environment.apiUrl}${endpoint}`, params, {
      headers: {
        Authorization: `Bearer ${this.weathermapTokenService.token()}`,
      },
    });
  }
}
